import {
  EDITION_COOKIE,
  EDITION_COOKIE_OPTIONS
} from '../constants';

const
  NAME               = 'editionJumper',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME]
;

const
  {Cookies} = Voonto,
  editions  = Voonto.getInstance().lookup('vocento.site.editions'),
  RELOAD_TIMEOUT = 300
;
class EditionJumper {
  constructor(element$) {
    var value;

    value = element$.data('voc-edition-jumper');
    if (value) {
      if (element$.val() === Cookies.get(EDITION_COOKIE)) {
        element$.prop('checked', true);
      }
      element$.on('click', _onEditionChange);
    }

    if (element$.get(0).tagName === 'SELECT') {
      element$.val(Cookies.get(EDITION_COOKIE) || editions.current).change();
      element$.on('change', _onEditionChange);
    }
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(/*config*/) {
    return this.each(function() {
      new EditionJumper($(this));
    });
  }
}

$.fn[NAME]             = EditionJumper._jQueryInterface;
$.fn[NAME].Constructor = EditionJumper;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return EditionJumper._jQueryInterface;
};

export default EditionJumper;

/* Private */

function _onEditionChange() {
  Cookies.set(EDITION_COOKIE, this.value, EDITION_COOKIE_OPTIONS);
  setTimeout(function() {document.location = '/';}, RELOAD_TIMEOUT);
}



// WEBPACK FOOTER //
// ./src/plugins/edition-jumper.js